import { Component, inject, Input, OnInit } from '@angular/core'
import { IonicModule, ModalController } from '@ionic/angular'
import { NgClass, NgIf } from '@angular/common'

@Component({
  selector: 'app-advanced-toast',
  templateUrl: './advanced-toast.component.html',
  styleUrls: ['./advanced-toast.component.scss'],
  imports: [IonicModule, NgIf, NgClass],
})
export class AdvancedToastComponent implements OnInit {
  private modalCtrl = inject(ModalController)

  @Input() message: string
  @Input() ionIconName?: string
  @Input() durationMs?: number
  @Input() iconAnimation?: 'spin'
  @Input() spinner = false

  ngOnInit() {
    if (this.durationMs) {
      setTimeout(async () => {
        await this.modalCtrl.dismiss()
      }, this.durationMs)
    }
  }
}
